/**
 * Imports
 */
import { _ } from '@api'
export const CustomAttributeService = {
  buildCustomAttributeUpdateInputForSpecifications: (originalData, updatedData) => {
    const attributesInUpdatedObject = _.map(updatedData.attributes, (attribute) => attribute.name)
    const attributesInOriginalObject = _.map(originalData.attributes, (attribute) => attribute.name)

    let addedAttributes = _.difference(attributesInUpdatedObject, attributesInOriginalObject)
    let updatedAttributes = _.difference(attributesInUpdatedObject, addedAttributes)

    if (addedAttributes.length || updatedAttributes.length) {
      let attributeUpdateInput: any = {}
      if (addedAttributes.length) {
        attributeUpdateInput.create = _.map((addedAttributes), (attribute) => {
          const attrObject = _.find(updatedData.attributes, (element) => element.name === attribute)
          // Remove definition from object
          let createObj = _.omit(attrObject, ['customAttributeDefinition', 'id', '__typename'])

          if (createObj.tag && !_.isEmpty(createObj.tag)) {
            const tag = createObj.tag
            createObj.tag = {
              connect: {
                id: tag.id
              }
            }
          }

          if (createObj.tagList && createObj.tagList.length) {
            const tagList = [...createObj.tagList]
            createObj.tagList = {
              connect: _.map(tagList, (tag) => ({id: tag.id}))
            }
          }
          // Connect attribute definition
          createObj.customAttributeDefinition = {
            connect: {
              id: attrObject.customAttributeDefinition.id
            }
          }
          createObj.name = attrObject.customAttributeDefinition.name

          return createObj
        })
      }

      if (updatedAttributes.length) {
        attributeUpdateInput.update = _.map((updatedAttributes), (attribute) => {
          const attrObject = _.find(updatedData.attributes, (element) => element.name === attribute)
          const originalAttrObject = _.find(originalData.attributes, (element) => element.name === attribute)
          const attributeType = attrObject && attrObject.customAttributeDefinition ? attrObject.customAttributeDefinition.type : ''

          // Remove definition from object
          let dataObj = _.omit(attrObject, ['customAttributeDefinition', 'id', '__typename'])

          if(attributeType === 'Tag') {
            if(dataObj.tag) {
              const tag = dataObj.tag
              dataObj.tag = {
                connect: {
                  id: tag.id
                }
              }
            } else if(originalAttrObject.tag) {
              dataObj.tag = {
                disconnect: {
                  id: originalAttrObject.tag.id
                }
              }
            }
          }

          if (attributeType === 'TagList' && dataObj.tagList && (dataObj.tagList.length || originalAttrObject.tagList.length)) {
            const updatedTags = _.map(dataObj.tagList, (tag) => tag.id)
            const originalTags = _.map(originalAttrObject.tagList, (tag) => tag.id)
            const addedTags = _.difference(updatedTags, originalTags)
            const deletedTags = _.difference(originalTags, updatedTags)

            dataObj.tagList = {}
            dataObj.tagList.connect = _.map(addedTags, (tagId) => ({id: tagId}))
            dataObj.tagList.disconnect = _.map(deletedTags, (tagId) => ({id: tagId}))
          }

          return {
            data: dataObj,
            where: {
              id: originalAttrObject.id
            }
          }
        })
      }

      return attributeUpdateInput
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/services/CustomAttributeService.ts